import { view } from "@risingstack/react-easy-state";
import { IconDot } from "@tine/designsystem-icons/sharp";
import { Tag } from "@tine/designsystem-ui-react";
import isUndefined from "lodash-es/isUndefined";
import { useEffect } from "react";

import type { Product } from "../../common/types/productTypes";

import authStore from "../../stores/auth/authStore";
import productStore from "../../stores/product/productStore";

type StockDisplayProps = {
   product: Product;
};

const StockDisplay = ({ product }: StockDisplayProps) => {
   const sku = product.sku;
   const loggedIn = authStore.isLoggedIn();

   useEffect(() => {
      if (loggedIn) {
         void productStore.checkStockForSku(sku);
      }
   }, [sku, loggedIn]);

   if (!loggedIn) {
      return (
         <div className="tw-mb-6">
            <Tag variant="base" icon={<IconDot />}>
               Logg inn for å se tilgjengelighet
            </Tag>
         </div>
      );
   }

   if (isUndefined(productStore.stockLevels[sku])) {
      return <div />;
   }

   const level = productStore.stockLevels[sku].data;

   if (level === null) {
      return (
         <div className="tw-mb-6" data-testid="check-stock-tag">
            <Tag variant="base">Sjekker lagerbeholdning...</Tag>
         </div>
      );
   }
   if (level >= 10) {
      return (
         <div className="tw-mb-6" data-testid="stock-tag">
            <Tag variant="success" icon={<IconDot />}>
               På lager
            </Tag>
         </div>
      );
   }
   if (level > 0 && level < 10) {
      return (
         <div className="tw-mb-6" data-testid="stock-tag">
            <Tag variant="warning" icon={<IconDot />}>
               Få på lager
            </Tag>
         </div>
      );
   }
   if (level <= 0) {
      return (
         <div className="tw-mb-6" data-testid="stock-tag">
            <Tag variant="error" icon={<IconDot />}>
               Ikke på lager
            </Tag>
         </div>
      );
   }
};

export default view(StockDisplay);
